import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "station-map",
  templateUrl: "./map.component.html",
})
export class StationMapComponent implements OnInit {
  @Input() station: any;

  getMapEmbedCode() {
    let html = ``;
    if (this.station && this.station.map_geocode_lat) {
      html = `<iframe src="https://maps.google.com/maps?q=${this.station.map_geocode_lat},${this.station.map_geocode_lng}&z=18&output=embed" width="100%" height="500" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" style="border: 0;"></iframe>`;
    }
    return html;
  }

  ngOnInit() {}
}
